export default __webpack_public_path__ + "img/catIcon8.180b9471.svg";